module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "recover-acc"
  }, [_c('div', {
    staticClass: "sec"
  }, [_c('top', {
    attrs: {
      "title": '活动详情'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con spcial",
    domProps: {
      "innerHTML": _vm._s(_vm.act_info.recover_info)
    }
  })], 1), _vm._v(" "), _c('price-form', {
    ref: "form",
    attrs: {
      "recover_description": _vm.config_info.recover_description,
      "title": '系统账号回收',
      "type": 2,
      "wechatShow": _vm.act_info.display_weixin_recover,
      "wechat": _vm.act_info.service_recover,
      "qqShow": _vm.act_info.display_qq_recover,
      "sale_extend": _vm.act_info.sale_extend * 1 || 0,
      "qq": _vm.act_info.qq_recover
    },
    on: {
      "submit": _vm.submitData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sec"
  }, [_c('top', {
    attrs: {
      "title": '活动细则'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con",
    domProps: {
      "innerHTML": _vm._s(_vm.act_info.recover_rule)
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c393067"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/recoverAcc/recoverAcc.vue
// module id = 612
// module chunks = 27